export * from './InfoMiniIcon'
